import { LoadPropType } from "@/components/select/types";

import { Autocomplete } from './interface';

export default class AutocompleteEntity {
    entityName: string;
    entity: Autocomplete;

    constructor(name: string) {
        this.entity = {
            name,
            title: '',
            // null is initial value and should be changed to a correct settings object
            // TODO: throw an error, if the field is not present
            settings: null,
        };
        this.entityName = name;
    }

    setTitle(title: string) {
        this.entity.title = title;

        return this;
    }

    setSettings(settings: LoadPropType) {
        this.entity.settings = settings;

        return this;
    }
}
